import { styled } from "styled-components";

export const DropOptionText = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-left: 15px;
`;
